import Vue from 'vue'
import * as jsonpatch from 'fast-json-patch/index.mjs'

const trackedBillDivision = {
  state: {
    trackedBillDivisions: [],
    selectedTrackedBillDivision: {},
    selectedTrackedBillDivisionOriginal: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    trackedBillDivisions(state) {
      return state.trackedBillDivisions
    },
    selectedTrackedBillDivision(state) {
      return state.selectedTrackedBillDivision
    },
    selectedTrackedBillDivisionOriginal(state) {
      return state.selectedTrackedBillDivisionOriginal
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    trackedBillDivisions(state, payload) {
      state.trackedBillDivisions = payload
    },
    selectedTrackedBillDivision(state, payload) {
      state.selectedTrackedBillDivision = JSON.parse(JSON.stringify(payload))
    },
    selectedTrackedBillDivisionOriginal(state, payload) {
      state.selectedTrackedBillDivisionOriginal = JSON.parse(
        JSON.stringify(payload)
      )
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedTrackedBillDivision(context, payload) {
      context.commit('selectedTrackedBillDivision', payload)
    },
    async loadTrackedBillDivisions(context, payload) {
      const url = 'TrackedBillDivision'
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('trackedBillDivisions', res.data)
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async refreshSelectedTrackedBillDivision(context, payload) {
      if (
        context.state.selectedTrackedBillDivision &&
        context.state.selectedTrackedBillDivision.Id > 0
      ) {
        return await context.dispatch(
          'loadSelectedTrackedBillDivision',
          context.state.selectedTrackedBillDivision.Id
        )
      }
    },
    async loadSelectedTrackedBillDivision(context, payload) {
      if (
        context.state.selectedTrackedBillDivision &&
        context.state.selectedTrackedBillDivision.Id != payload
      ) {
        context.commit('selectedTrackedBillDivision', {})
      }
      const url = 'TrackedBillDivision/' + payload
      context.commit('increaseSearchCount')
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('selectedTrackedBillDivision', res.data)
        context.commit('selectedTrackedBillDivisionOriginal', res.data)
        context.commit('decreaseSearchCount')
        return res
      } catch (err) {
        console.error(err)
        context.commit('decreaseSearchCount')
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async clearLookupCacheAndReloadTrackedBillDivisions(context, payload) {
      await caches.delete('apilookup-cache')
      return await context.dispatch('loadTrackedBillDivisions')
    },
    async createTrackedBillDivision(context, payload) {
      const url = `TrackedBillDivision`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.post(url, payload)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'tracked bill division created' },
          { root: true }
        )
        //if you will always need to reload the list after an item is created
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadTrackedBillDivisions')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async patchTrackedBillDivision(context, payload) {
      var item = context.state.selectedTrackedBillDivision
      if (
        payload.Id &&
        payload.Id == context.state.selectedTrackedBillDivisionOriginal.Id
      ) {
        item = payload
      }
      var patchPayload = {}
      if (!payload.patchDoc || !payload.Id) {
        let original = context.state.selectedTrackedBillDivisionOriginal
        let current = item
        patchPayload.Id = item.Id
        var diff = jsonpatch.compare(original, current)
        patchPayload.patchDoc = diff
      } else {
        patchPayload = payload
      }
      if (patchPayload.patchDoc.length > 0) {
        const url = `TrackedBillDivision/${patchPayload.Id}`
        context.commit('saving', true)
        try {
          let res = await Vue.prototype.$axios.patch(url, patchPayload.patchDoc)
          context.dispatch(
            'messages/toastMessage',
            { color: 'success', message: 'tracked bill division updated' },
            { root: true }
          )
          //if you will always need to reload the list after an update
          //you can uncomment out the following dispatch line.
          //Alternatively you can reload whatever object you need
          //when the promise resolves in the component that called it.
          //context.dispatch('loadTrackedBillDivisions')
          context.commit('saving', false)
          return res
        } catch (err) {
          console.error(err)
          context.commit('saving', false)
          context.dispatch('errors/handleError', err, { root: true })
          throw err
        }
      } else {
        return 'no changes'
      }
    },
    async updateTrackedBillDivision(context, payload) {
      const url = `TrackedBillDivision/${payload.Id}`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.put(url, payload)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'tracked bill division updated' },
          { root: true }
        )
        //if you will always need to reload the list after an update
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadTrackedBillDivisions')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async saveTrackedBillDivision(context, payload) {
      if (payload.Id > 0) {
        return context.dispatch('updateTrackedBillDivision', payload)
      } else {
        return context.dispatch('createTrackedBillDivision', payload)
      }
    },
    async deleteTrackedBillDivision(context, payload) {
      const url = `TrackedBillDivision/${payload.Id}`
      try {
        let res = await Vue.prototype.$axios.delete(url)
        context.dispatch(
          'messages/toastMessage',
          { color: 'success', message: 'tracked bill division deleted' },
          { root: true }
        )
        //if you will always need to reload the list after a delete
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadTrackedBillDivisions')
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
  },
}

export default trackedBillDivision
